import { render } from "./Klarna.vue?vue&type=template&id=d44dbfaa"
import script from "./Klarna.vue?vue&type=script&lang=js"
export * from "./Klarna.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__